import { createContext, useContext, useMemo } from 'react';

import { useSegmentationConfig } from '../../hooks/useSegmentationConfig';
import { normalizeConditionName } from '../../utils/skinConditionNormalization';

const SegmentationContext = createContext(null);

export function useSegmentation() {
  const ctx = useContext(SegmentationContext);
  if (!ctx) {
    throw new Error('useSegmentation must be used within SegmentationRenderer');
  }
  return ctx;
}

export function isConcernAllowed(config, concernName) {
  if (!config?.allowedNames) return true;
  const key = normalizeConditionName(concernName);
  return config.allowedNames.has(key);
}

const SegmentationRenderer = ({ appSessionToken, children }) => {
  const config = useSegmentationConfig(appSessionToken);
  const value = useMemo(() => config, [config]);
  return (
    <SegmentationContext.Provider value={value}>
      {children}
    </SegmentationContext.Provider>
  );
};

export default SegmentationRenderer;
